import notify from '@/plugins/notify';

import {
    IDraftState,
    IDraftUnit,
    IDraftUnitOptions,
    IAssignPlayerPayload,
} from './DraftArea-types';
import api from '../../helpers/api';
import vm from '../../main';

const draftState: IDraftState = {
    state: {
        draftUnits: [],
        submitting: false,
    },
    mutations: {
        setDraftUnits(state, draftUnits: IDraftUnit[]) {
            state.draftUnits = draftUnits;
        },
        setSubmitting(state, value: boolean) {
            state.submitting = value;
        },
    },
    actions: {
        async getDraftUnits({ commit }, gameId) {
            const response = await api.request(`/game/${gameId}/draftUnits`, 'GET');
            const draftUnits: IDraftUnit[] = await response.json();

            if (response.ok) {
                commit('setDraftUnits', draftUnits);
            }
        },
        async draftUnit({ commit, state }, options: IDraftUnitOptions) {
            if (state.submitting) {
                return;
            }

            await commit('setSubmitting', true);

            const { gameId, unitTypeId } = options;
            const response = await api.request(`/game/${gameId}/draftUnit`, 'POST', { unitTypeId });

            if (response.status === 400) {
                const error = await response.json();

                notify({
                    group: 'app',
                    clean: true,
                });

                notify({
                    group: 'app',
                    type: 'info',
                    text: error.message,
                });
            }

            await commit('setSubmitting', false);
        },
        async eliminateDraftUnit({ commit, state }, options: IDraftUnitOptions) {
            if (state.submitting) {
                return;
            }

            await commit('setSubmitting', true);

            const { gameId, unitTypeId } = options;
            const response = await api.request(`/game/${gameId}/eliminateDraftUnit`, 'POST', { unitTypeId });

            if (response.status === 400) {
                const error = await response.json();

                notify({
                    group: 'app',
                    clean: true,
                });

                notify({
                    group: 'app',
                    type: 'info',
                    text: error.message,
                });
            }

            await commit('setSubmitting', false);
        },
        async assignPlayer({ commit, state }, payload: IAssignPlayerPayload) {
            if (state.submitting) {
                return;
            }

            await commit('setSubmitting', true);

            const { gameId, draftingPlayerId } = payload;

            const endpoint = draftingPlayerId ? 'assignDraftingPlayer' : 'assignStartingPlayer';
            const successMsg = `${draftingPlayerId ? 'Drafting' : 'Starting'} player assigned successfully`;

            const response = await api.request(`/game/${gameId}/${endpoint}`, 'POST', payload);

            if (response.ok) {
                notify({
                    group: 'app',
                    type: 'success',
                    text: successMsg,
                });
            }

            if (response.status === 400) {
                const error = await response.json();

                notify({
                    group: 'app',
                    clean: true,
                });

                notify({
                    group: 'app',
                    type: 'info',
                    text: error.message,
                });
            }

            await commit('setSubmitting', false);
        },
    },
};

export default draftState;
